module.exports = __webpack_public_path__ + "60447ce3ece4a2c46b5a91a6b2059f28.svg";